import { useState } from "react";
import styles from "./complaintfilter.module.css";
import { Link } from "react-router-dom";
import { Select, FormControl, InputLabel, MenuItem } from "@mui/material";
import { Search, Plus, Filter, ArrowRight } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import axios from "axios";

const ComplaintFilter = ({ setAddModalOpen, setFilterData, setSortData, setPage }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [allProperties, setAllProperties] = useState([]);
    const [apartmentList, setApartmentList] = useState([]);

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let propertyData = response.data.data;
                propertyData = [{ value: "all", label: "Any" }].concat(propertyData);

                setAllProperties(propertyData);
            }).catch((error) => { });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    setPage(0);
                }} />
            </div>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Complaints</span>
            </Link>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Property"
                            onChange={(e) => {
                                setFilterData((prev) => { return { ...prev, property: e.target.value, apartment: "" }; });
                                setPage(0);

                                if (e.target.value !== "all") {
                                    let propertyTemp = allProperties.filter((i) => i.value === e.target.value);
                                    setApartmentList([{ value: "all", label: "Any" }].concat(propertyTemp[0]?.apartments));
                                } else {
                                    setApartmentList([]);
                                }
                            }}
                        >
                            {allProperties?.map((i) => {
                                return (<MenuItem value={i.value}>{i.label}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Apartment</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Apartment"
                            onChange={(e) => {
                                setFilterData((prev) => { return { ...prev, apartment: e.target.value }; });
                                setPage(0);
                            }}
                        >
                            {apartmentList.length === 0 && <MenuItem disabled value={''}>Select Property First</MenuItem>}
                            {apartmentList?.map((i) => {
                                return (<MenuItem value={i.value}>{i.label}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width130} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Status"
                            onChange={(e) => {
                                setFilterData((prev) => { return { ...prev, status: e.target.value }; });
                                setPage(0);
                            }}
                        >
                            <MenuItem value={"all"}>{"Any"}</MenuItem>
                            <MenuItem value={"Open"}>{"Open"}</MenuItem>
                            <MenuItem value={"Resolved"}>{"Resolved"}</MenuItem>
                            <MenuItem value={"Cancelled"}>{"Cancelled"}</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width130} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Priority</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Priority"
                            onChange={(e) => {
                                setFilterData((prev) => { return { ...prev, priority: e.target.value }; });
                                setPage(0);
                            }}
                        >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={"Low"}>Low</MenuItem>
                            <MenuItem value={"Medium"}>Medium</MenuItem>
                            <MenuItem value={"High"}>High</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width130} CusSelectFilter Filter`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Sort by Date</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Sort by Date"
                            onChange={(e) => setSortData(e.target.value)}
                        >
                            <MenuItem value="latest">Latest - Earliest</MenuItem>
                            <MenuItem value="erliest">Earliest - Latest</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Complaints</span>
            </Link>
        </div>
    </div>);
};

export default ComplaintFilter;